/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignInvoiceStatusPathParams, CampaignInvoiceStatusResponse } from '../types/CampaignInvoiceStatus'

/**
 * GET /:organisation/campaign/:campaign/invoice/status
 * @see backend/nexus/modules/Billing/Http/Controllers/CampaignInvoiceController.php CampaignInvoiceController::status
 */
export async function campaignInvoiceStatus(
	organisation: CampaignInvoiceStatusPathParams['organisation'],
	campaign: CampaignInvoiceStatusPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignInvoiceStatusResponse>> {
	return axiosInstance.get(`/${organisation}/campaign/${campaign}/invoice/status`, config)
}
